import type { ComponentProps } from "react";

export default function PencilIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1021_5595)">
        <path
          d="M14.9998 1.66663L18.3332 4.99996M1.6665 18.3333L2.73017 14.4332C2.79957 14.1787 2.83426 14.0515 2.88753 13.9329C2.93482 13.8275 2.99294 13.7274 3.06093 13.6341C3.13752 13.5289 3.23076 13.4357 3.41726 13.2492L12.0284 4.63803C12.1934 4.47302 12.2759 4.39052 12.3711 4.35961C12.4548 4.33242 12.5449 4.33242 12.6286 4.35961C12.7237 4.39052 12.8062 4.47302 12.9712 4.63803L15.3618 7.02855C15.5268 7.19356 15.6093 7.27607 15.6402 7.3712C15.6674 7.45489 15.6674 7.54503 15.6402 7.62872C15.6093 7.72385 15.5268 7.80636 15.3618 7.97136L6.75059 16.5825C6.5641 16.769 6.47085 16.8623 6.36574 16.9389C6.27241 17.0069 6.17227 17.065 6.06693 17.1123C5.94829 17.1655 5.82107 17.2002 5.56662 17.2696L1.6665 18.3333Z"
          stroke="rgba(13,48,80,0.8)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1021_5595">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
